import i18n from 'services/base/i18n';

export default {
  stepNameReboot:      () => i18n.pgettext('Pages|Manage Updates|Restore Stepper|Steps|Name', 'Reboot Pangolin Device'),
  stepNameRestore:     () => i18n.pgettext('Pages|Manage Updates|Restore Stepper|Steps|Name', 'Restore Data Snapshot'),
  stepNameInstall:     () => i18n.pgettext('Pages|Manage Updates|Restore Stepper|Steps|Name', 'Fetch and Flash Image'),
  stepNameSwitch:      () => i18n.pgettext('Pages|Manage Updates|Restore Stepper|Steps|Name', 'Swap and Verify Firmware'),

  stepLabelSkipped:    () => i18n.pgettext('Pages|Manage Updates|Restore Stepper|Steps|Labels', 'Skipped'),
  stepLabelPending:    () => i18n.pgettext('Pages|Manage Updates|Restore Stepper|Steps|Labels', 'Pending'),
  stepLabelCompleted:  () => i18n.pgettext('Pages|Manage Updates|Restore Stepper|Steps|Labels', 'Completed'),
  stepLabelInProgress: () => i18n.pgettext('Pages|Manage Updates|Restore Stepper|Steps|Labels', 'In Progress'),
  stepLabelFailed:     () => i18n.pgettext('Pages|Manage Updates|Restore Stepper|Steps|Labels', 'Failed'),
};
